import { render, staticRenderFns } from "./LowerBodyFat.vue?vue&type=template&id=258d3e3d&"
import script from "./LowerBodyFat.vue?vue&type=script&lang=js&"
export * from "./LowerBodyFat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports